import React from 'react'
import { Td, Text } from '@chakra-ui/react'

export const TableBodyProjectList = (props) => {
  const { project, onClickOpenProjectDetail } = props

  return (
    <>
      <Td>
        <Text>{project.client_name}</Text>
      </Td>
      <Td>
        <Text>{project.assigner}</Text>
      </Td>
      <Td>
        <Text
          color="#3b5998"
          fontWeight="semibold"
          as="a"
          cursor="pointer"
          onClick={() => onClickOpenProjectDetail(project.project_id)}
        >
          {project.project_name}
        </Text>
      </Td>
      <Td>
        <Text>{project.count}</Text>
      </Td>
      <Td>
        <Text>{project.due_date}</Text>
      </Td>
      <Td>
        <Text>
          {project.project_status == 'pending'
            ? '検討中'
            : project.project_status == 'manufacturing'
            ? '製作中'
            : project.project_status == 'done'
            ? '納品済み'
            : 'キャンセル'}
        </Text>
      </Td>
      <Td>
        <Text>{project.registered_date}</Text>
      </Td>
    </>
  )
}
